export const stripCpf = (value: string): string => value.replace(/\D/g, "");

export const formatCpfDisplay = (value?: string | null): string => {
  if (!value) {
    return "";
  }

  const digits = stripCpf(value);

  if (digits.length <= 3) {
    return digits;
  }

  if (digits.length <= 6) {
    return `${digits.slice(0, 3)}.${digits.slice(3)}`;
  }

  if (digits.length <= 9) {
    return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6)}`;
  }

  return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6, 9)}-${digits.slice(9, 11)}`;
};

export const isValidCpf = (value: string): boolean => {
  const cpf = stripCpf(value);

  if (cpf.length !== 11) {
    return false;
  }

  if (/^(\d)\1{10}$/.test(cpf)) {
    return false;
  }

  for (let position = 9; position < 11; position += 1) {
    let sum = 0;

    for (let index = 0; index < position; index += 1) {
      sum += Number(cpf[index]) * (position + 1 - index);
    }

    const checkDigit = ((10 * sum) % 11) % 10;

    if (Number(cpf[position]) !== checkDigit) {
      return false;
    }
  }

  return true;
};
